module.exports = "https://images.shiksha.ws/saassets/media/SA_profile.15580011.svg";